import { Button, Icon, Tooltip } from '@lego/klik-ui';
import { BoltSolid } from '@lego/klik-ui/icons';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRepositories } from '@/hooks/repository';
import { paths } from '@/utility/global_paths';
import { getRepositoryTableColumns } from '../common/table/column_definitions/Repository';
import { TableStoreProvider } from '../common/table/store/Context';
import { Table } from '../common/table/Table';

type Props = {
  workspaceId: number;
};

const repositoriesDescription =
  'Docker repositories associated with this workspace. Click each repository to view its contents';

export const WorkspaceRepositoryTable = ({ workspaceId }: Props) => {
  const navigate = useNavigate();
  const { data, isLoading, mutate, isValidating } = useRepositories(workspaceId);
  const repositoryTableColumns = useMemo(
    () => getRepositoryTableColumns(workspaceId),
    [workspaceId]
  );

  return (
    <TableStoreProvider initialSorting={[{ desc: true, id: 'id' }]} name="WorkspaceRepository">
      <Table
        addButton={() => (
          <Tooltip
            label="Compose Docker Service from Store and Workspace services"
            placement="left"
          >
            <Button
              borderRightRadius="0px"
              colorScheme="warning"
              display={{ base: 'none', md: 'flex' }}
              leftIcon={<Icon as={BoltSolid} />}
              onClick={() => navigate(paths.workspaceAppWizard(workspaceId))}
              size="sm"
              variant="outline"
            >
              Compose Service
            </Button>
          </Tooltip>
        )}
        columns={repositoryTableColumns}
        count={data?.itemCount || 0}
        data={data?.repositories || []}
        description={repositoriesDescription}
        isLoading={Boolean(isLoading || !data)}
        isValidating={isValidating}
        refresh={mutate}
        rowLink={({ id }) => paths.repositoryById(workspaceId, id)}
        title="Workspace Repositories"
      />
    </TableStoreProvider>
  );
};
